import TooltipWidget from '../Tooltip/Tooltip';

import {Badge} from '@deere/fuel-react';
import React from 'react';
import {useTranslation} from 'react-i18next';
import './DataCard.css';

const DataCard = (props) => {
  const {t} = useTranslation();

  const cardHeadObject = props.cardHead?.reduce((acc, key) => {
    if (props.data && props.data[key] !== undefined) {
      acc[key] = props.data[key];
    }
    return acc;
  }, {});

  const cardBodyObject = props.cardBody?.reduce((acc, key) => {
    if (props.data && props.data[key] !== undefined) {
      acc[key] = props.data[key];
    }
    return acc;
  }, {});

  return (
    <div className={'dataCardWrapper'}>
      {props.badge ? (
        <Badge className={`dataCardBadge ${props.badgeClass}`} type="success">
          {t(props.badge)}
        </Badge>
      ) : null}

      <div className={`dataCardHead ${props.badge && 'badgeHead'}`}>
        {cardHeadObject &&
          Object.keys(cardHeadObject).map((key, index) => (
            <div className={'dataCardItem'} key={'dataCardHeadItem' + key}>
              {!cardHeadObject[key].hideTitle && (
                <div
                  className={`dataCardItemTitle ${
                    cardHeadObject[key].value == '' ? 'visibleHidden' : ''
                  }`}
                >
                  {t(key)}
                </div>
              )}
              <div className={'dataCardItemValue'}>
                {cardHeadObject[key]?.component}
              </div>
            </div>
          ))}
      </div>
      <div className={'dataCardBody'}>
        {cardBodyObject &&
          Object.keys(cardBodyObject).map((key, index) => (
            <div className={'dataCardItem'} key={'dataCardBodyItem' + key}>
              <div className={'dataCardItemTitle'}>
                {t(key)}
                {cardBodyObject[key]?.infoIconText && (
                  <TooltipWidget
                    tooltip={cardBodyObject[key].infoIconText}
                    placement="top"
                  />
                )}
              </div>
              <div className={'dataCardItemValue'}>
                {cardBodyObject[key]?.component}
              </div>
            </div>
          ))}
      </div>
      <div className={'dataCardFooter'}>
        {props.cardFooter && props.cardFooter}
      </div>
    </div>
  );
};
export default DataCard;
